import { render, staticRenderFns } from "./PartnerVideoCard.vue?vue&type=template&id=2231c4bb&scoped=true&"
import script from "./PartnerVideoCard.vue?vue&type=script&lang=js&"
export * from "./PartnerVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerVideoCard.vue?vue&type=style&index=0&id=2231c4bb&lang=scss&scoped=true&"
import style1 from "./PartnerVideoCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231c4bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
